/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Log } from '../logging/Log';
import { MessageService } from './MessageService';

export class OverrideFeatures {
    private TAG: string = 'OverrideFeatures';

    private oOverrideFeatures: { [key: string]: any } = {};

    private GET_OVERRIDE_FEATURES: string = 'KaveriApp.BackdoorEntry.getOverriddenFeatures';

    initialize = async () => {
        return new Promise((resolve, reject) => {
            new MessageService(this.GET_OVERRIDE_FEATURES)
                .getResponse()
                .then((response) => {
                    this.oOverrideFeatures = <JSON>response;
                    resolve(true);
                })
                .catch((error) => {
                    Log.e(this.TAG, 'Failed to initialize Override Features', error);
                    reject(error);
                });
        });
    };

    public getOverriddenSlsBaseUrl = (): string => {
        return this.oOverrideFeatures?.slsServiceEndpoint || '';
    };

    public getOverriddenSlsEnvironment = (): string => {
        return this.oOverrideFeatures?.slsEnvironment || '';
    };
}
